// 计费单

import { HttpGetInventoryBatchList, HttpGetInventoryBatchListExport,HttpGetProduct } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import { mapGetters } from 'vuex';
import mixin from "../mixin";
export default {
    mixins: [TableList, mixin],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            products:[],
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    watch:{
        "$route":function (to,from) {
            this.$set(this.formData,"search[EQ_organizationId]",this.isAdmin() ? '' : global.SYSID)
            this.updateList();
        }
    },
    methods: {
        ajaxRequest: HttpGetInventoryBatchList,
        interceptResponse(params){
            if(params.content.length>0){
                let productIds = [];
                params.content.forEach(item => {
                    productIds.push(item.productId);
                  });
                HttpGetProduct({
                    contextId: global.SYSID,
                    productIds:productIds
                  })
                    .then(res => {
                        this.products = res.data;
                    })
                    .catch(err => {
                      this.$VMessage.error(err.message);
                    });
            }
            
        },
        interceptRequest(params) {
            
            params.state = this.isAdmin() ? '1' : '0';
            this.formData.state = params.state;
            return params
            
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpGetInventoryBatchListExport, this.formData, 'download').then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
        isAdmin() {
            return this.$route.name === 'inventorySerBatchList';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSelfmanageorgList','getBillcusorgList', 'getCusproductList', 'getSystemWareList','getAdminTransferWarehouse', 'getTransferWarehouse']),
        // ...mapGetters('common', ['getInventoryType', 'getInventoryBatchListType']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: this.isAdmin() ? 'IN_orgWarehouseCode' : 'IN_orgWarehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inventory.source_order', { defaultValue: "来源单据" }),
                    key: 'EQ_srcLabel',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryBatchListType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.inbound.batch_no', { defaultValue: "批次号" }),
                    key: 'EQ_batchNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
                    key: 'EQ_sourceNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inventory.plan_order', { defaultValue: "计划单号" }),
                    key: 'CN_planNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('fbb.inventory.inbound_time', { defaultValue: "入库时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_stockinAt',
                    default: this.handleDateRange().join(' ~ '),
                    show: true,
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [ 
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.isAdmin() ? this.getCusproductList : this.getProductList,
                            row.lineId
                        )
                },
                {
                    title: this.$t('fbb.inbound.batch_no', { defaultValue: '批次号' }),
                    key: 'batchNo',
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.receive_number', { defaultValue: '接收数量' }),
                    key: 'qty',
                    sortable: true
                },
                {
                    title: this.$t('fbb.inventory.now_number', { defaultValue: '当前数量' }),
                    key: 'qtyCurrent',
                    sortable: true
                },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }
                       
                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }
                        
                        
                    }
                },
                {
                    title: this.$t('fbb.inventory.source_order', { defaultValue: '来源单据' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let srcLabel = row.srcLabel
                        const { label } = this.getInventoryBatchListType.find(function (item) {
                            return item.value == srcLabel
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: 'sourceNo',
                },
                {
                    title: this.$t('fbb.inventory.plan_order', { defaultValue: '计划单号' }),
                    key: 'planNo',
                },
                {
                    title: this.$t('fbb.inventory.inbound_time', { defaultValue: '入库时间' }),
                    key: 'stockinAt',
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    width: 150,
                    key: 'updatedAt',
                },
            ];
        },
    },
};




